"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.STORE_HOURS_LABEL = exports.STORE_CLOSED = exports.PICK_UP_TIME_TEXT = exports.ORDER_BUTTON_TEXT_PICKUP = exports.ORDER_BUTTON_TEXT_KIOSK = exports.ORDER_BUTTON_TEXT_DELIVERY = exports.ORDER_BUTTON_TEXT = exports.DINING_OPTION_PICKUP_LABEL = exports.DINING_OPTION_DELIVERY_LABEL = exports.DELIVERY_TIME_TEXT = void 0; // Location Card StandardStickysWeb, StandardWeb, Type3 Component

var DELIVERY_TIME_TEXT = "Delivery time: {deliveryEstimate}";
exports.DELIVERY_TIME_TEXT = DELIVERY_TIME_TEXT;
var DINING_OPTION_DELIVERY_LABEL = "Delivery Hours";
exports.DINING_OPTION_DELIVERY_LABEL = DINING_OPTION_DELIVERY_LABEL;
var DINING_OPTION_PICKUP_LABEL = "Pickup Hours";
exports.DINING_OPTION_PICKUP_LABEL = DINING_OPTION_PICKUP_LABEL;
var ORDER_BUTTON_TEXT = "Order";
exports.ORDER_BUTTON_TEXT = ORDER_BUTTON_TEXT;
var ORDER_BUTTON_TEXT_DELIVERY = ORDER_BUTTON_TEXT;
exports.ORDER_BUTTON_TEXT_DELIVERY = ORDER_BUTTON_TEXT_DELIVERY;
var ORDER_BUTTON_TEXT_KIOSK = ORDER_BUTTON_TEXT;
exports.ORDER_BUTTON_TEXT_KIOSK = ORDER_BUTTON_TEXT_KIOSK;
var ORDER_BUTTON_TEXT_PICKUP = ORDER_BUTTON_TEXT;
exports.ORDER_BUTTON_TEXT_PICKUP = ORDER_BUTTON_TEXT_PICKUP;
var PICK_UP_TIME_TEXT = "Pickup time: {pickupEstimate}";
exports.PICK_UP_TIME_TEXT = PICK_UP_TIME_TEXT;
var STORE_HOURS_LABEL = "Store Hours";
exports.STORE_HOURS_LABEL = STORE_HOURS_LABEL;
var STORE_CLOSED = "Closed";
exports.STORE_CLOSED = STORE_CLOSED;
var _default = {
  DELIVERY_TIME_TEXT: DELIVERY_TIME_TEXT,
  DINING_OPTION_DELIVERY_LABEL: DINING_OPTION_DELIVERY_LABEL,
  DINING_OPTION_PICKUP_LABEL: DINING_OPTION_PICKUP_LABEL,
  ORDER_BUTTON_TEXT: ORDER_BUTTON_TEXT,
  ORDER_BUTTON_TEXT_DELIVERY: ORDER_BUTTON_TEXT_DELIVERY,
  ORDER_BUTTON_TEXT_KIOSK: ORDER_BUTTON_TEXT_KIOSK,
  ORDER_BUTTON_TEXT_PICKUP: ORDER_BUTTON_TEXT_PICKUP,
  PICK_UP_TIME_TEXT: PICK_UP_TIME_TEXT,
  STORE_HOURS_LABEL: STORE_HOURS_LABEL,
  STORE_CLOSED: STORE_CLOSED
};
exports["default"] = _default;